import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import environment from '../environments/environment';
import { EAvailableContentType } from '../models/Enums';

interface SignalRMessage {
    contentId: number;
    contentType: EAvailableContentType;
    isBundleContent: boolean;
}

export class SignalService {
    public builder = new HubConnectionBuilder();

    public connection: any;

    public bearer = '';
    // cb(bearer: string) {
    //     this.connection.send('ConnectionMessage', bearer);
    // }

    /**
     * if this.connection not initialized creates one
     * and sends bearer to socket channel
     * @param {string} bearer - token bearer
     * */

    invoke(message: string, bearer: string): void {
        this.connection.invoke(message, bearer);
    }

    postMessage(message: string, content?: SignalRMessage): void {
        this.connection.invoke(message, content);
    }

    async connect(bearer: string = this.bearer): Promise<void> {
        if (!this.connection) {
            this.bearer = bearer;
            this.connection = await this.builder
                .withUrl(environment.signalRUri, {
                    accessTokenFactory: () => bearer.substring(7, bearer.length),
                })
                // .withAutomaticReconnect()
                .configureLogging(LogLevel.Information)
                .build();
            await this.connection.start({ pingInterval: 60000 })
                .catch((error: { message: any }) => {
                    console.error('happened');
                    console.error(error.message);
                });
        }
    }

    async close(): Promise<void> {
        try {
            await this.connection.stop();
            //  this.cb(bearer);
        } catch (error) {
            console.error(error);
        }
    }
}

export const signalService = new SignalService();
